import Vue from "vue";
import Vuex from "vuex";

import api from "./api";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: JSON.parse(localStorage.getItem("user"))
  },
  getters: {
    isAuthenticated: state => !!state.user
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      localStorage.setItem("user", JSON.stringify(user));
    },
    clearUser(state) {
      state.user = null;
      localStorage.removeItem("user");
      state.tackleBoxItems = [];
    }
  },
  actions: {
    signIn({ commit }, { email, password }) {
      // The Promise used for router redirect in Signin.vue
      return new Promise((resolve, reject) => {
        api
          .createSession(email, password)
          .then(response => {
            commit("setUser", response.data);
            resolve();
          })
          .catch(error => {
            // if the request fails, clear user
            commit("clearUser");
            reject(error.response.data.error);
          });
      });
    },
    signUp({ commit }, { email, password }) {
      // The Promise used for router redirect in Signup.vue
      return new Promise((resolve, reject) => {
        api
          .createUser(email, password)
          .then(response => {
            commit("setUser", response.data);
            resolve();
          })
          .catch(error => {
            commit("clearUser");
            reject(error.response.data.errors);
          });
      });
    },
    signOut({ commit }) {
      // The Promise used for router redirect in Header.vue
      return new Promise(resolve => {
        api.deleteSession().then(() => {
          commit("clearUser");
          resolve();
        });
      });
    }
  }
});
